// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AAWf","content":"styles_content__20-HB","tableWrap":"styles_tableWrap__2RsSh"};